module.exports = __webpack_public_path__ + "static/media/BasisGrotesque-Regular.bd37fdf8.woff";